import { useEntity } from 'hooks/useEntity'
import Alert from "components/ui/Alert/Alert";
import { useTitle } from "hooks/useTitle";
import TopBanner from "layout/TopBanner/TopBanner";
import Hero from "features/games/assets/images/hero-games.svg?v2";
import Loader from "components/ui/Loader/Loader";
import "features/games/components/Games.scss";
import Game from "features/games/components/Game";

function GameOverview({ title, path }) {
  const { entity, error, loading } = useEntity(path, 'page');

  useTitle(title);

  if (loading) {
    return <Loader/>;
  }

  if (error) {
    return <Alert/>;
  }

  return (
    <>
      <TopBanner title={ entity?.title?.value || '' }
                 intro={ entity?.field_intro?.value || '' }
                 image={ Hero }>
      </TopBanner>

      <div className="wrapper--fluid grid">
        <div className="content content--wide content--background content--games">
          <Game/>
        </div>
      </div>
    </>
  )
}

export default GameOverview;
